import classNames from "classnames"
import React from "react"
import style from "./style.scss"

interface WysiwygProps {
  className?: string
  content: string
}

const Wysiwyg: React.SFC<Readonly<WysiwygProps>> = (props) => {
  return (
    <div
      className={classNames(style.wysiwyg, props.className)}
      dangerouslySetInnerHTML={{ __html: props.content }}
    />
  )
}

export default Wysiwyg
